export const blockIconsAudioandvideoVideoCall = (
	<span className='material-symbols-outlined'>video_call</span>
);
